<i18n locale="en">
{
  "no-data": "Design your own text!\n\nhttps://owner.com"
}
</i18n>

<template>
  <div
    class="flex-col align-end justify-center text-preview"
    :class="{ 'text-preview--padded': padded }"
  >
    <div class="flex-col gap-3 text-preview__bubble">
      <OwnType
        color="primary"
        variant="paragraph-regular"
        :text="content.data?.text || t('no-data')"
        text-wrap
        hotlink-urls
        preserve-whitespace
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnType } from '@/ui/OwnType'

interface ContentData {
  text?: string
}

interface Content {
  data?: ContentData
}

withDefaults(
  defineProps<{
    content: Content
    padded?: boolean
  }>(),
  {
    padded: true,
  }
)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.text-preview {
  &--padded {
    padding: 20px;
  }

  &__bubble {
    background-color: var(--background-secondary);
    padding: 16px;
    border-radius: 18px;
    width: 220px;
  }
}
</style>
